<div *ngIf="(activeStepIndex$ | async) !== undefined">
  <div *ngIf="cart$ | async as cart">
    <div class="cx-media">
      <div class="cx-list-media" *ngIf="cart?.totalItems && cart?.subTotal">
        {{ 'cartItems.cartTotal' | cxTranslate: { count: cart.totalItems } }}:
        {{ cart.subTotal?.formattedValue }}
      </div>
      <div *ngFor="let step of steps$ | async; let i = index">
        <div class="cx-list-media" *ngIf="i < activeStepIndex">
          <div>{{ i + 1 }}. {{ step.name | cxTranslate }}</div>
          <button class="btn btn-link" [routerLink]="{ cxRoute: step.routeName } | cxUrl">
            {{ 'common.edit' | cxTranslate }}
          </button>
        </div>
        <div class="cx-list-media is-active" *ngIf="i === activeStepIndex">
          <div>{{ i + 1 }}. {{ step.name | cxTranslate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
